<template>
    <div class="two-columns">
        <slot />
    </div>
</template>

<style scoped lang="scss">
.two-columns {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: size(md);
    align-items: start;
}
</style>
